// Metric type ID constants matching coaching_metric_type table

export const METRIC_TYPE_NUMERIC = 1;
export const METRIC_TYPE_PERCENTAGE = 2;
export const METRIC_TYPE_CURRENCY = 3;
export const METRIC_TYPE_DECIMAL = 4;
export const METRIC_TYPE_TIME = 5;

export interface MetricTypeConfig {
    regex: RegExp;
    placeholder: string;
    suffix: string;
    hint: string;
}

export const getMetricTypeConfig = (metricTypeId?: number, metricTypeName?: string): MetricTypeConfig => {
    switch (metricTypeId) {
        case METRIC_TYPE_PERCENTAGE:
            return {
                regex: /^-?\d{0,3}(\.\d{0,2})?$/,
                placeholder: '0.00',
                suffix: '%',
                hint: 'Enter a percentage value',
            };
        case METRIC_TYPE_CURRENCY:
            return {
                regex: /^-?\d*(\.\d{0,2})?$/,
                placeholder: '0.00',
                suffix: '$',
                hint: 'Enter a currency value (up to 2 decimal places)',
            };
        case METRIC_TYPE_NUMERIC:
            return {
                regex: /^-?\d*$/,
                placeholder: '0',
                suffix: '',
                hint: 'Enter a whole number',
            };
        case METRIC_TYPE_DECIMAL:
            return {
                regex: /^-?\d*(\.\d{0,4})?$/,
                placeholder: '0.0000',
                suffix: '',
                hint: 'Enter a decimal value (up to 4 decimal places)',
            };
        case METRIC_TYPE_TIME:
            return {
                regex: /^-?\d*(\.\d{0,2})?$/,
                placeholder: '0.00',
                suffix: 's',
                hint: 'Enter time in seconds (e.g. 120.50)',
            };
        default:
            return {
                regex: /^-?\d*(\.\d{0,4})?$/,
                placeholder: '0.00',
                suffix: '',
                hint: metricTypeName ? `Type: ${metricTypeName}` : 'Data type is defined by metric.',
            };
    }
};
